module.exports = __webpack_public_path__ + "img/744.9f58423c.jpg";